import { MatSnackBarConfig } from '@angular/material/snack-bar';
import { SnackbarConfig } from '@qaroni-core/conf/snackbars/snackbar.config';

export const OAuthSnackbars = {
  failureLogin: {
    message: `Credenciales incorrectas`,
    closeBtn: 'Cerrar',
    config: {
      panelClass: SnackbarConfig.classes.danger,
      duration: SnackbarConfig.durations.danger,
    } as MatSnackBarConfig,
  },
};
